module.exports = __webpack_public_path__ + "media/applicants/shopper3-099d5dae.jpg";